import React from "react";
import { motion } from "framer-motion";
import { MASHY } from "@/lib/api";

const SRC = {
  happy: MASHY.happy,
  celebrate: MASHY.celebrate,
  confused: MASHY.confused,
};

export default function Mashy({ mood = "happy", size = 120, bounce = true, className = "", "data-testid": testId }) {
  const src = SRC[mood] || SRC.happy;
  return (
    <motion.img
      data-testid={testId || `mashy-${mood}`}
      src={src}
      alt={`Mashy ${mood}`}
      style={{ width: size, height: size, objectPosition: "center 45%" }}
      className={`object-cover rounded-3xl ${bounce ? "mashy-bounce" : ""} ${className}`}
      initial={{ scale: 0.6, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 220, damping: 14 }}
      draggable={false}
    />
  );
}

export function MashyBubble({ message, mood = "happy" }) {
  return (
    <div className="flex items-end gap-3" data-testid="mashy-bubble">
      <Mashy mood={mood} size={84} />
      <div className="card-chunky px-4 py-3 max-w-xs">
        <p className="text-sm md:text-base text-gray-700">{message}</p>
      </div>
    </div>
  );
}
